import { cn } from "@bleu.builders/ui";
import React from "react";
import { Link } from "react-router-dom";
import useSWR from "swr";

import { theses } from "#/api/all";
import { formatDate } from "#/lib/formatDate";
import { replaceParams, UserPagePath } from "#/lib/pagesHelper";
import { client } from "#/utils/api-client";

export function ThesisRelatedNewsArticles({ thesis_id }) {
  const { data, error, isLoading } = useSWR(
    [theses.latestNewsArticles.path({ id: thesis_id }), {}],
    async ([url]) => await client(url),
    {
      keepPreviousData: true,
    },
  );

  if (isLoading) {
    return (
      <div className="animate-pulse text-muted-foreground">Carregando...</div>
    );
  }

  if (error) {
    return <div>Erro ao carregar notícias relacionadas.</div>;
  }

  if (data?.data?.length === 0) {
    return <div>Não foram localizadas notícias recentes.</div>;
  }

  return (
    <div className="w-full flex gap-2">
      {data?.data.map((item, index, list) => (
        <div key={index} className="flex items-center justify-between gap-2">
          <Link
            to={replaceParams(UserPagePath.NEWS_ARTICLE, {
              news_article_id: item.id,
            })}
            unstable_viewTransition
            className={cn("hover:scale-[101%] no-underline", {
              "border-r": index % 3 !== 2 && index !== list.length - 1,
              "px-4": index % 3 === 1,
              "pr-4": index % 3 === 0,
              "pl-4": index % 3 === 2,
            })}
          >
            <h1 className="text-base font-semibold text-foreground mb-0">
              {item.title}
            </h1>
            <p className="text-sm text-muted-foreground my-0">
              {formatDate(item.published_at)}
            </p>
          </Link>
        </div>
      ))}
    </div>
  );
}
